<template>
	<div :style="{width:width}" class="el-pr">
		<el-input :maxlength="maxSize"
				  type="textarea"
				  :autosize="{ minRows:minRows, maxRows:maxRows}"
				  :placeholder="placeholder"
				  :disabled="disabled"
				  :readonly="readonly"
				  v-model.trim="currentValue"
				  @input="handleModelInput"
				  @blur="formatContent"
				  class="textAreaPaddingBottom18">
		</el-input>
		<p class="word-counter" v-show="!disabled"><span style="color:#b3b5b0">{{contentShortLength}}/{{maxSize}}</span>
		</p>
	</div>
</template>
<script type="text/ecmascript-6">
	export default {
		name: "textareaSize",
		data() {
			return {
				currentValue: this.value
			}
		},
		methods: {
			handleModelInput(val) {
				const value = val
				this.$emit('input', value)
				if (this.$parent.$options.componentName === 'ElFormItem') {
					if (this.validateEvent) {
						this.$parent.$emit('el.form.change', [value])
					}
				}
				this.$emit('change', value)
			},
			formatContent() {

				if (!this.format) {
					this.$emit('blur', this.currentValue)
					if (this.$parent.$options.componentName === 'ElFormItem') {
						if (this.validateEvent) {
							this.$parent.$emit('el.form.change', [this.currentValue])
						}
					}
					return
				}
				if (!this.currentValue) {
					return
				}
				var lines = this.currentValue.split('(\n\r)|(\n)'), line = null, i = 0, allLine = [];

				for (var len = lines.length; i < len; i++) {
					var line = lines[i];
					if (line == '' && i !== 0) {
						allLine.push('\n\r');
					} else {
						allLine.push(replaceSpace(line));
					}
				}


				function replaceSpace(str) {
					var links = str.match(/(<a\b[^>]+>(.*?)<\/a>)/ig), links2 = [];
					str = "\u3000\u3000" + str.replace(/[ \u3000\t\r]/g, "").replace(/[\n]+/g, "\r\n\r\n\u3000\u3000");
					if (links && links.length) {
						links2 = str.match(/(<a[^>]+>(.*?)<\/a>)/ig);
						for (var i = 0, len = links2.length; i < len; i++) {
							str = str.replace(links2[i], links[i])
						}
					}
					return str;
				}

				this.currentValue = allLine.join('');
				this.$emit('input', this.currentValue)
				this.$emit('blur', this.currentValue)
				if (this.$parent.$options.componentName === 'ElFormItem') {
					if (this.validateEvent) {
						this.$parent.$emit('el.form.change', [this.currentValue])
					}
				}

			}
		},
		computed: {
			contentShortLength() {

				if (this.currentValue) {
					if (this.noBlank) {
						return this.currentValue.replace(/\t|\|n|\|r|\|v|\s|\u3000/g, '').length
					} else {
						return this.currentValue.length
					}
				} else {
					return 0
				}
			}
		},
		watch: {
			'value': function (newValue) {

				this.currentValue = newValue
				/*if (newValue && newValue.length > this.maxSize) {
                    this.$nextTick( ()=> {
                        this.currentValue = newValue.substring(0, this.maxSize);
                    })
                } else {
                    this.currentValue = newValue
                }*/
			}
		},
		props: {
			'maxSize': {
				type: Number
			},
			value: [String, Number],
			'width': {
				type: String,
				default: '85%'
			},
			'minRows': {
				type: Number,
				default: 3
			},
			maxRows: {
				type: Number,
				default: 8
			},

			placeholder: {
				type: String,
				default: '请输入内容'
			},
			disabled: {
				type: Boolean,
				default: false
			},
			readonly: {
				type: Boolean,
				default: false
			},
			noBlank: {
				type: Boolean,
				default: false
			},
			format: {
				type: Boolean,
				default: false
			}
		},
		created() {
		}
	}
</script>
<style scoped lang="scss">

	.word-counter {
		position: absolute;
		right: 20px;
		font-size: 12px;
		bottom: 2px;
		background: #fff;
		line-height: 16px;
		span {
			color: #FA5555
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/components/textareaSize.vue